/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import axios from 'axios';
import * as utils from 'ui-camping/src/shared/utils/utils';

export const fetchGateway = async (gatewayId) => {
    try {
        const output = await axios.get(
            `${process.env.API}/external/inventory/gateway/${gatewayId}`
        );
        const transformed = utils.transformGatewayFromBackEnd(output.data);
        return {
            results: {
                ...transformed,
                isValid: true,
            },
        };
    } catch (error) {
        return {
            results: {
                isValid: false,
                error,
            },
        };
    }
};
